import { render, staticRenderFns } from "./ScopeOfFunctionsRoleSelect.vue?vue&type=template&id=e8e93c20&"
import script from "./ScopeOfFunctionsRoleSelect.vue?vue&type=script&lang=ts&"
export * from "./ScopeOfFunctionsRoleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VSelect})
